export const Slutsk = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.19639929964427, 52.93630905514942],
            [27.19638089184417, 52.93642000266101],
            [27.20263036796956, 52.94045541941841],
            [27.208433453263808, 52.94233848547918],
            [27.2146829293892, 52.944490460394434],
            [27.220039622954403, 52.94744925052038],
            [27.227181881640035, 52.948525124521495],
            [27.231199401813797, 52.948794088570025],
            [27.239234442161376, 52.94583538988718],
            [27.245930310016035, 52.94341448604621],
            [27.253072567803372, 52.94099344673282],
            [27.26333956500082, 52.93857227194417],
            [27.27137460534857, 52.93615096113547],
            [27.281195210816634, 52.932653273966935],
            [27.289230251164213, 52.928886217428385],
            [27.295926119018873, 52.92404237696206],
            [27.29503333645863, 52.919467141411985],
            [27.291462207115785, 52.91650643719157],
            [27.285212730990565, 52.91246878727583],
            [27.278963254865175, 52.909238396316255],
            [27.272267387908812, 52.90466159653141],
            [27.271820996179542, 52.90169988012116],
            [27.274945734691244, 52.899007234775695],
            [27.28030242825639, 52.89819940865277],
            [27.285212730990565, 52.89846868606145],
            [27.288337469502267, 52.899276507164984],
            [27.295926119018873, 52.89954577733897],
            [27.30306837680621, 52.89846868606145],
            [27.308871462100626, 52.893082826465275],
            [27.31154980888317, 52.88904299306273],
            [27.313335374003827, 52.88419469597966],
            [27.317352894177645, 52.88177034357017],
            [27.322709587742622, 52.880962196157725],
            [27.32851267303704, 52.880962196157725],
            [27.335208539993403, 52.880962196157725],
            [27.34056523355855, 52.88015403368371],
            [27.349493056466372, 52.878807063117506],
            [27.353956968369403, 52.877729455889664],
            [27.360206444494793, 52.87665182242688],
            [27.36645592062024, 52.87584357962123],
            [27.37672291691939, 52.87584357962123],
            [27.38297239304478, 52.877998859935985],
            [27.390561042561387, 52.88230910032473],
            [27.39547134529539, 52.885541499194915],
            [27.409309470937387, 52.89254420412658],
            [27.417790903014406, 52.89873796125528],
            [27.424040379139626, 52.90250764098914],
            [27.432075419487376, 52.90681544499279],
            [27.44011046073325, 52.90869997421987],
            [27.447699110249857, 52.90977681172063],
            [27.456180542326877, 52.909507604584235],
            [27.461537235891853, 52.907353889970636],
            [27.46510836523464, 52.90250764098914],
            [27.466447538626028, 52.899007234775695],
            [27.46912588540846, 52.89793013011246],
            [27.476268144094092, 52.89954577733897],
            [27.480285664268024, 52.900622841844836],
            [27.490999051397978, 52.90116136432937],
            [27.499034092644024, 52.90143062279094],
            [27.50439078620923, 52.902776891084784],
            [27.50885469811226, 52.90573853387622],
            [27.509301088943232, 52.909238396316255],
            [27.509747479774205, 52.9148914223955],
            [27.510640262334448, 52.919197995044385],
            [27.515996955899595, 52.92296589466747],
            [27.520460867802626, 52.92350413943126],
            [27.52581756136783, 52.92404237696206],
            [27.531174255831104, 52.925118833033366],
            [27.537423731956494, 52.92807894841161],
            [27.54278042552164, 52.928348039576065],
            [27.550369075038248, 52.92619526179817],
            [27.552154639260436, 52.92404237696206],
            [27.55527937777225, 52.920005429670255],
            [27.560636071337456, 52.916775600829965],
            [27.561975244728615, 52.91327634737263],
            [27.561082462168372, 52.909507604584235],
            [27.555725768603395, 52.90573853387622],
            [27.552154639260436, 52.902238389220145],
            [27.551708248429463, 52.89793013011246],
            [27.555725768603395, 52.893082826465275],
            [27.561082462168372, 52.89038964621176],
            [27.568224720854005, 52.887965640747666],
            [27.577598935491267, 52.88500278314592],
            [27.583402019887217, 52.8839468794053],
            [27.591401349507464, 52.88360208900747],
            [27.597115156635482, 52.882740101017134],
            [27.60282896286543, 52.88032644293486],
            [27.60282896286543, 52.87756781265864],
            [27.599972059750485, 52.87411927749042],
            [27.59425825262241, 52.87222246656489],
            [27.588830136703905, 52.869290868339704],
            [27.587115994835074, 52.86704892370676],
            [27.587115994835074, 52.86497933401796],
            [27.590258588261463, 52.861357313963765],
            [27.594543942933797, 52.85859747710998],
            [27.601971891931044, 52.85687248940246],
            [27.609114150616676, 52.85876997205543],
            [27.614256576223454, 52.861184829302545],
            [27.623112976778202, 52.866531535539934],
            [27.632826448267224, 52.87205002509472],
            [27.644539751936804, 52.87808506920254],
            [27.653110462179825, 52.88342969278017],
            [27.660252720865458, 52.88773939336522],
            [27.66882343110848, 52.88998026808463],
            [27.67368016640404, 52.890497376569726],
            [27.679393973532115, 52.888773657629656],
            [27.683965018516062, 52.88791177245611],
            [27.689678825644307, 52.88842890561659],
            [27.693678490005084, 52.88946315343077],
            [27.704820413051664, 52.89200557455257],
            [27.715533801080085, 52.89362144265266],
            [27.729480350513256, 52.89157475915465],
            [27.729818317553224, 52.8944293541129],
            [27.730264709282494, 52.899276507164984],
            [27.732496664335656, 52.903584631874594],
            [27.7378533587991, 52.905469302185054],
            [27.747227572537895, 52.905469302185054],
            [27.7566017871751, 52.90412311754932],
            [27.763297654131463, 52.905469302185054],
            [27.769547130256854, 52.90869997421987],
            [27.772225477039456, 52.91246878727583],
            [27.77088630364824, 52.91731392200478],
            [27.769547130256854, 52.92081284924001],
            [27.769547130256854, 52.92565705103209],
            [27.774903823821887, 52.928348039576065],
            [27.780706909116304, 52.92780985503276],
            [27.78650999441072, 52.92780985503276],
            [27.79142029624643, 52.930500710298304],
            [27.795884208149516, 52.93426762633055],
            [27.800348120052718, 52.93830324379951],
            [27.812400680574058, 52.94153146735732],
            [27.82356045943351, 52.94368348187129],
            [27.8342738474621, 52.94556640744179],
            [27.844987234592054, 52.94771822179996],
            [27.852129493277687, 52.94960097122265],
            [27.855700622620702, 52.953097289150605],
            [27.857039796011918, 52.95793787766428],
            [27.85659340428265, 52.96519774508903],
            [27.856147013451675, 52.97272520874992],
            [27.859271751963547, 52.97702602815741],
            [27.865074836359497, 52.980788893896204],
            [27.877573788610277, 52.9821326946776],
            [27.885162438126883, 52.98240145025096],
            [27.897661390377664, 52.98293895530071],
            [27.897761039770046, 52.98291287005861],
            [27.903089507194295, 52.98898005659419],
            [27.905375029686297, 52.99379513356746],
            [27.911660217437316, 52.99843773512731],
            [27.917945404290265, 53.00222022617413],
            [27.923944901729897, 53.005142833742354],
            [27.93051577979253, 53.0072057313414],
            [27.939943560071868, 53.00789334196634],
            [27.950799793705187, 53.01047178479416],
            [27.95937050305008, 53.0115031185793],
            [27.963370168309325, 53.015284464939725],
            [27.967084142358715, 53.01958104780044],
            [27.973655020421347, 53.02490821624497],
            [27.98051158789724, 53.02971928691585],
            [27.983654182221926, 53.03367083594094],
            [27.985368324090928, 53.03779380596336],
            [27.984796943467927, 53.04140108141701],
            [27.980225897585683, 53.042259911911],
            [27.976511923536293, 53.0431187252957],
            [27.973655020421347, 53.04552331175171],
            [27.971940878552346, 53.05050381468726],
            [27.969655355162047, 53.0535948720721],
            [27.963370168309325, 53.054968603946634],
            [27.957942051492466, 53.055655453460986],
            [27.949942721872446, 53.058746141327845],
            [27.946800128446057, 53.06321007606954],
            [27.946800128446057, 53.070248418531264],
            [27.945657367200113, 53.078658587921495],
            [27.942514773773723, 53.08380686040164],
            [27.93794372789148, 53.086895528036905],
            [27.93537251508809, 53.092729073842065],
            [27.93651527633392, 53.09787566353464],
            [27.943086154396553, 53.10302163763339],
            [27.950799793705187, 53.10645194469208],
            [27.95708498055808, 53.109710483539516],
            [27.964227239243712, 53.11245432430354],
            [27.97108380761796, 53.114683566549616],
            [27.97794037509385, 53.118970244992965],
            [27.981082969418537, 53.12222783529995],
            [27.98051158789724, 53.12599947348201],
            [27.97736899447068, 53.13217053083014],
            [27.971940878552346, 53.13474154296097],
            [27.969083974539103, 53.140054481070706],
            [27.96994104547366, 53.14502405419455],
            [27.973655020421347, 53.15033572065414],
            [27.979654516962682, 53.15239167301962],
            [27.986225395025315, 53.15307696859884],
            [27.99451041495695, 53.15136370914206],
            [27.998795769629453, 53.149479044242355],
            [28.00679509924953, 53.14725160698691],
            [28.013365977312162, 53.147594297161675],
            [28.01793702229611, 53.15136370914206],
            [28.01793702229611, 53.1561606638914],
            [28.01479442886972, 53.15941543473946],
            [28.010223382987476, 53.162327389497136],
            [28.003366815511527, 53.16421148990224],
            [27.996795937448894, 53.16678058443881],
            [27.997367318071895, 53.170548312108906],
            [28.00365250582314, 53.17174706500356],
            [28.01222321606616, 53.17294578440766],
            [28.02165099724374, 53.17534312328456],
            [28.024222210047128, 53.17825399689178],
            [28.02222237786674, 53.18219192381429],
            [28.01165183544316, 53.18424635058574],
            [28.002224054265582, 53.18441754837471],
            [27.988796607828874, 53.18339035139053],
            [27.96765552298166, 53.18304794692858],
            [27.944228915642498, 53.18270553973315],
            [27.9074819958459, 53.183229849740314],
            [27.874002659267433, 53.18483484029019],
            [27.864628445528524, 53.186172286712804],
            [27.86373566296828, 53.212912454120044],
            [27.86373566296828, 53.21455830696533],
            [27.855016076729783, 53.21281778773795],
            [27.844289356804154, 53.20950851386135],
            [27.835187897636672, 53.20658835421443],
            [27.827061594744407, 53.20483616290346],
            [27.818935291852085, 53.20327859919149],
            [27.81535971854356, 53.20327859919149],
            [27.807883520134226, 53.20405738785439],
            [27.799107112758975, 53.206977720511304],
            [27.797156800208597, 53.21028718984991],
            [27.798131956483815, 53.21398570620266],
            [27.80235763337697, 53.215932165149184],
            [27.804958050410335, 53.2188516885534],
            [27.808858676409443, 53.22332790399719],
            [27.809183728201674, 53.22897116099546],
            [27.808533623718915, 53.23480823083713],
            [27.80625825937608, 53.240255444561285],
            [27.803657842342716, 53.24531295128918],
            [27.80138247710181, 53.252703615941584],
            [27.800082269034192, 53.25775965154935],
            [27.79683174751807, 53.26437048816064],
            [27.794231330484706, 53.26650906952386],
            [27.790005653591493, 53.270591518961],
            [27.790655757176182, 53.27525669754738],
            [27.796506695725668, 53.277006008264834],
            [27.800082269034192, 53.277006008264834],
            [27.80560815489315, 53.27661727909492],
            [27.811134040752222, 53.277006008264834],
            [27.813409405993184, 53.280310067232904],
            [27.81210919702744, 53.283225200637105],
            [27.807233415651297, 53.28614013519234],
            [27.80105742530941, 53.290415013215124],
            [27.795206486759923, 53.29430089519593],
            [27.795856591242853, 53.29682652829058],
            [27.800407320826594, 53.29818642317122],
            [27.80658331116831, 53.29896348613647],
            [27.811134040752222, 53.301683095984004],
            [27.814384562268344, 53.30517948304623],
            [27.814384562268344, 53.309646671627206],
            [27.807233415651297, 53.31314240662874],
            [27.799432164551206, 53.314890166515454],
            [27.791955966141927, 53.315084357462126],
            [27.785779975799983, 53.311977193076814],
            [27.782854506974445, 53.30809291979955],
            [27.77992903814885, 53.30440253264533],
            [27.77635346484027, 53.301488844072935],
            [27.770502526290784, 53.30071182705598],
            [27.75685033753956, 53.301683095984004],
            [27.74677372209692, 53.30479100961287],
            [27.738972470996885, 53.30925823883729],
            [27.727920699278968, 53.31411339282067],
            [27.719144291903717, 53.31566692553787],
            [27.71296830156183, 53.316055300016615],
            [27.70646725942771, 53.314890166515454],
            [27.700616320878225, 53.31294820631052],
            [27.695090435019324, 53.312365601128135],
            [27.69086475812611, 53.312171397812676],
            [27.680138038200482, 53.31294820631052],
            [27.67688751668436, 53.315084357462126],
            [27.676237412201374, 53.317997118865264],
            [27.680463089992884, 53.319744679971734],
            [27.685663924059384, 53.321103844514255],
            [27.690539705435583, 53.322268808929834],
            [27.69314012246889, 53.324598641279636],
            [27.694115278744107, 53.32692834642097],
            [27.693790226951705, 53.33061678643412],
            [27.685013819576625, 53.33508131322935],
            [27.679487933717667, 53.33702226637081],
            [27.674937204133926, 53.33760453498195],
            [27.66876121379204, 53.33838088112202],
            [27.66193511896722, 53.34032168357089],
            [27.653158712490438, 53.34245646462506],
            [27.645682513182635, 53.34342678441794],
            [27.64048168001443, 53.34148612275152],
            [27.639181471048516, 53.33741044650702],
            [27.642106939874054, 53.33449901017002],
            [27.645357461390404, 53.33178149060069],
            [27.646007565873333, 53.327510752830335],
            [27.643732200632257, 53.322268808929834],
            [27.641131783598894, 53.31993884883195],
            [27.63365558518956, 53.319162167553884],
            [27.6281296993306, 53.319162167553884],
            [27.621303604505954, 53.318967994623335],
            [27.61830844438049, 53.31721480939416],
            [27.61644446531875, 53.31514680925807],
            [27.612450224985594, 53.3124423502822],
            [27.608056560439252, 53.31109005626962],
            [27.602730907260536, 53.311965074807745],
            [27.601798917729695, 53.31443093993903],
            [27.603396613683344, 53.31729434571537],
            [27.606725147593863, 53.319600838851215],
            [27.610186822609137, 53.32158909501197],
            [27.6121839427758, 53.32357725853967],
            [27.61378163872928, 53.32667860818327],
            [27.611651377457918, 53.32954119280487],
            [27.605376051411895, 53.33449901017002],
            [27.605194022192677, 53.34168019321453],
            [27.60165745463206, 53.34490939014961],
            [27.601424217379986, 53.34506209942987],
            [27.595208420461233, 53.34913181755928],
            [27.589799553642763, 53.35149122728643],
            [27.581686252965994, 53.35397467502901],
            [27.57502918514507, 53.35608549235633],
            [27.5683721182225, 53.3575754178666],
            [27.56109095034958, 53.355837166016386],
            [27.557138317285364, 53.35372633692657],
            [27.55360174972475, 53.35298131340227],
            [27.545904515449763, 53.35322965584521],
            [27.540703682281503, 53.35620965444741],
            [27.53862334847514, 53.359561903832514],
            [27.53363054805851, 53.36353459904922],
            [27.5309261142001, 53.36663800938152],
            [27.52759758028975, 53.369989438449466],
            [27.52302084717354, 53.37358882767154],
            [27.51927624686101, 53.376691505631925],
            [27.51220311263819, 53.37830480893126],
            [27.50804244502558, 53.3779325136357],
            [27.502217511805213, 53.37507814121511],
            [27.503673744661114, 53.37098240365731],
            [27.508666545077574, 53.367631052710124],
            [27.51178704533794, 53.36452771471431],
            [27.517820013106814, 53.3593135982847],
            [27.519900346913232, 53.356457978617016],
            [27.520316413315186, 53.35248462363916],
            [27.517611979456774, 53.34925600044369],
            [27.513451312742347, 53.34739322187659],
            [27.50908261237788, 53.34689646700008],
            [27.50013717799885, 53.34826252831266],
            [27.493480110177927, 53.352112102652825],
            [27.49035960991762, 53.35695462154325],
            [27.48931944346367, 53.36130000376477],
            [27.486615009605316, 53.365148400719136],
            [27.483078442942997, 53.36775518169969],
            [27.477669575226116, 53.36787930979153],
            [27.472052674757606, 53.36787930979153],
            [27.46789200804335, 53.36564494236944],
            [27.466435774288982, 53.36192073625347],
            [27.464979540534785, 53.35683046162234],
            [27.462275107574726, 53.35434717973749],
            [27.457698373560163, 53.35273296897617],
            [27.45395377324769, 53.35136705091344],
            [27.452705573143533, 53.34913181755928],
            [27.45395377324769, 53.34590293988293],
            [27.457698373560163, 53.34354322139512],
            [27.459986740118097, 53.34081075202829],
            [27.460194773768308, 53.33807810756167],
            [27.45894657366415, 53.33472416843148],
            [27.45603410705405, 53.332363830759164],
            [27.452705573143533, 53.33149420016832],
            [27.443552105114463, 53.32938216512639],
            [27.43793520464584, 53.32813974329463],
            [27.43086207042296, 53.32602754217646],
            [27.425453203604548, 53.32229987397619],
            [27.422748769746136, 53.318944694155675],
            [27.4206001129765, 53.316260876558886],
            [27.422249814894656, 53.314125530337094],
            [27.42334686626566, 53.31008365395593],
            [27.426089492896722, 53.30636916051384],
            [27.426455176387663, 53.3011246189555],
            [27.429014961722316, 53.29686295450057],
            [27.43157474795521, 53.29555158815367],
            [27.436511476430155, 53.293584462068736],
            [27.44181388929411, 53.292054412781454],
            [27.441631047099577, 53.289322045756535],
            [27.440351154432165, 53.28669880869893],
            [27.437608527801103, 53.28516851279255],
            [27.431209063566143, 53.28363816207974],
            [27.425358125914784, 53.282982280403644],
            [27.419690029559888, 53.28276365112043],
            [27.415850351557822, 53.28210775602207],
            [27.41548466806688, 53.27904678055501],
            [27.417678769910708, 53.27686023550899],
            [27.42554096721102, 53.27412689622662],
            [27.43157474795521, 53.27303351157377],
            [27.439071261764752, 53.273252191171366],
            [27.443642307646996, 53.271830756477186],
            [27.446384934278058, 53.268769044960834],
            [27.445105041610645, 53.26614454613474],
            [27.44254525627605, 53.263629250482836],
            [27.44254525627605, 53.26089506518974],
            [27.446019250787117, 53.2575044329717],
            [27.450773137965598, 53.25345719774566],
            [27.4549785003569, 53.251050551745664],
            [27.46357206553745, 53.24809675622049],
            [27.474725416052763, 53.244048630370855],
            [27.484196621791227, 53.24037216308324],
            [27.488175260184505, 53.24079234669665],
            [27.494143216876182, 53.24268312244578],
            [27.498472910594444, 53.24534407233057],
            [27.502837344859586, 53.24651721184432],
            [27.508265461676274, 53.24651721184432],
            [27.51426495821778, 53.24412385253356],
            [27.516550481607908, 53.240875507928536],
            [27.516836171919465, 53.23762691622534],
            [27.516836171919465, 53.23352307967281],
            [27.517978933165466, 53.231128993641846],
            [27.5228356684608, 53.22890579387894],
            [27.526549643408487, 53.226682478137775],
            [27.53140637870382, 53.22326176778813],
            [27.53140637870382, 53.22103815899504],
            [27.527978094966045, 53.21744593254897],
            [27.523121358772244, 53.215906314165636],
            [27.518836004099853, 53.2152220218054],
            [27.51169374541422, 53.2152220218054],
            [27.507408390741887, 53.2152220218054],
            [27.50169458361364, 53.2143666409836],
            [27.495409396760863, 53.210260574751715],
            [27.486552996206285, 53.20564078045612],
            [27.481981950323984, 53.20238951498686],
            [27.47912504720904, 53.20050709097302],
            [27.46798312416246, 53.19930914173597],
            [27.461126555788383, 53.19913800339742],
            [27.456555510804435, 53.198795724670845],
            [27.452270155233805, 53.19691314228021],
            [27.448270490872858, 53.19434585196444],
            [27.447413419938414, 53.19126490010086],
            [27.45141308429919, 53.188526090831715],
            [27.45684120111605, 53.18647186907543],
            [27.46055517516544, 53.18441754837471],
            [27.463983458903385, 53.18116467352502],
            [27.465697601670456, 53.17911009859881],
            [27.46741174353963, 53.176199283084145],
            [27.46855450478563, 53.17363075188791],
            [27.46798312416246, 53.16952078297197],
            [27.465697601670456, 53.16712311875722],
            [27.46369776859177, 53.16421148990224],
            [27.461983626722827, 53.160443205844615],
            [27.45798396236205, 53.157017206460694],
            [27.450841703676247, 53.153933572691926],
            [27.44569927806947, 53.15290564572956],
            [27.44254525627605, 53.15182286953285],
            [27.439254103959286, 53.14853325427214],
            [27.43852273607928, 53.1452433875329],
            [27.439985470941224, 53.14337901764543],
            [27.44272809847058, 53.13921131015525],
            [27.44254525627605, 53.136907929982044],
            [27.440533996626698, 53.13394625940538],
            [27.436145792939158, 53.13219109927894],
            [27.42828359474038, 53.13241049814815],
            [27.421152764421834, 53.13328808296205],
            [27.416216035048762, 53.13405595476854],
            [27.41018225520287, 53.13449473234266],
            [27.40579405151516, 53.13449473234266],
            [27.397749012020142, 53.13405595476854],
            [27.392629440452424, 53.1330686885737],
            [27.38769271197765, 53.13021645850381],
            [27.385864293624763, 53.12747375073377],
            [27.383304508290166, 53.123853108871856],
            [27.37909914679716, 53.1230850547355],
            [27.373979575229384, 53.1230850547355],
            [27.369042846754496, 53.12275588432169],
            [27.363374750399544, 53.12154890528927],
            [27.360997806361183, 53.12078080997924],
            [27.358986546712003, 53.11902511209473],
            [27.356792444868177, 53.11704986579133],
            [27.352769924671577, 53.11518427280993],
            [27.347650354002155, 53.113647840478336],
            [27.342165099841736, 53.113428345817454],
            [27.337959738348786, 53.113647840478336],
            [27.334668585133898, 53.11331859833649],
            [27.33247448329024, 53.111891851278415],
            [27.33119459062283, 53.10914797462311],
            [27.329000488779002, 53.10717227452449],
            [27.32333239242405, 53.10607462473865],
            [27.32095544928393, 53.10629415693694],
            [27.315287352929033, 53.108489417828594],
            [27.30870504739761, 53.108818697486356],
            [27.303219793237247, 53.10805037472255],
            [27.2977345381787, 53.10662345286363],
            [27.29645464551129, 53.10475740747785],
            [27.297551696882294, 53.102342404302306],
            [27.30285410974642, 53.097951142391025],
            [27.30523105288654, 53.09487699239281],
            [27.30523105288654, 53.09059477417759],
            [27.30413400241366, 53.087190655851884],
            [27.295906120724112, 53.083676445135325],
            [27.286946871154328, 53.082248714701734],
            [27.28201014267944, 53.082248714701734],
            [27.2772562555009, 53.083676445135325],
            [27.271588159146006, 53.086092495622495],
            [27.262080384788987, 53.087190655851884],
            [27.256777971925032, 53.08543358635916],
            [27.250195666393665, 53.083676445135325],
            [27.245076095724187, 53.080820937452415],
            [27.238310948896412, 53.07763572449909],
            [27.231545801170455, 53.0768668447414],
            [27.225877704815503, 53.07598810797356],
            [27.21234741026177, 53.076207793712],
            [27.204850896452285, 53.07598810797356],
            [27.199182800097333, 53.072912388860914],
            [27.198085748726328, 53.069726590792015],
            [27.20137690194116, 53.065551740168246],
            [27.20667931480517, 53.06214564121444],
            [27.212895935947472, 53.058739272926005],
            [27.218198348811427, 53.05500294679041],
            [27.218564032302254, 53.05082666903053],
            [27.214541512105654, 53.04774915285407],
            [27.207410681787053, 53.044671416378094],
            [27.205947946925107, 53.041703391680585],
            [27.20664788814338, 53.03826620451139],
            [27.203076758800535, 53.033971482592335],
            [27.196827282675144, 53.031555513731064],
            [27.19013141571878, 53.03021325014225],
            [27.182096375371202, 53.03021325014225],
            [27.17272216073394, 53.03021325014225],
            [27.156397815490777, 53.027410040095276],
            [27.15310666227589, 53.021691372821294],
            [27.152558136590415, 53.01355196208908],
            [27.155300764119772, 53.00992172992335],
            [27.15950612561278, 53.00772144033709],
            [27.16115170266943, 53.003870664197336],
            [27.15914044212178, 52.99990950726192],
            [27.155849289805246, 52.99715849031486],
            [27.150729719135825, 52.992646442511216],
            [27.14963266776482, 52.988904386693264],
            [27.15274097878512, 52.98670302634861],
            [27.158226232945367, 52.98659295514295],
            [27.164687120386418, 52.985895115701055],
            [27.170043813951395, 52.9821326946776],
            [27.173614943294183, 52.97810116586055],
            [27.175846899245812, 52.97111229125579],
            [27.176739680907758, 52.964928883049026],
            [27.178525246028414, 52.95578657170279],
            [27.178525246028414, 52.94475944952973],
            [27.18120359281096, 52.939648366173174],
            [27.188345851496592, 52.937765183575266],
            [27.19639929964427, 52.93630905514942],
          ],
        ],
      },
      properties: {
        id: "d7e0045e-39ec-11ef-895a-0242ac110004",
        shapeName: "Slutsk",
        shapeISO: "",
        shapeID: "67162791B93573624741448",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
